import type { ReactNode } from 'react';

export type CollapsibleItemBaseProps = {
  id: string;
  label: ReactNode;
  content: ReactNode;
  isCollapsible?: boolean;
};

// When the component is controlled by the parent (Accordion), these props would be passed.
export type CollapseItemInAccordion = {
  isExpandedViaParent: boolean;
  hasContentClickHandler?: boolean;
} & CollapsibleItemBaseProps;

// When the component works on its own, these props would be passed.
type CollapseItemSingle = {} & CollapsibleItemBaseProps;

export type CollapsibleProps = CollapseItemInAccordion | CollapseItemSingle;

// Type check helper
export const isItemInAccordion = (props: CollapsibleProps): props is CollapseItemInAccordion => {
  return 'isExpandedViaParent' in props;
};
